import requestManager from "../platformApi/requestManager";

import appHelper from "@util/appHelper";

export default {

    getTypeList(data,callback) {
        requestManager.request({
            url : 'portal/about/get_Agreement',
            data : {code:data}
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },

    loadVipCardBg(data, callback) {
        requestManager.request({
            url : 'portal/about/get_Agreement',
            data : {code:data}
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        });
    },
}
